import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { styled } from '@mui/material/styles';
import { Typography, Grid, Stack, Card, CardContent, Divider, Paper, } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStore } from '@mcn-platform/models';
import CourseHeadline from '../../item/card/ItemHeadline';
import CourseInfo from '../../item/card/ItemInfo';
import ItemInstructors from '../../item/card/ItemInstructors';
import PanelTitle from '../../item/LandingPageTabs/PanelTitle';
import CallToAction from '../../item/card/enrollPrice/CallToAction';
import { configureSalesCard } from '../../common/portalConfig';
import AssetImage from '../../common/asset/AssetImage';
import PlaceHolder from '../../common/PlaceHolder';
import { getInstructors } from '../../item/getData';
// import TotalRating from 'portal/course/Tab/reviewsContent/TotalRating';
const StyledDivider = styled(Divider)(() => ({
    borderBottomWidth: 1,
}));
const FeaturedCard = ({ item, 
// enrollAction,
settings: { showCourseInfo, showCourseHeadline, showOfferedBy, showInstructor, showPrice, showEnrollButton, }, editData, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
configId, limitToPageWidth, }) => {
    const { itemID, type } = item ?? {}; // null-safe destructuring
    const { currentPortal: portal, getOrLoad, getItemProgress } = useStore();
    const [itemProgress, setItemProgress] = useState(undefined);
    const navigate = useNavigate();
    const location = useLocation();
    let learningItemCommon = null;
    useEffect(() => {
        if (!itemID || !type) {
            return;
        }
        setItemProgress(getItemProgress(learningItemCommon));
    }, [getItemProgress, itemID, type, learningItemCommon]);
    if (!(item && item.itemID && item.type)) {
        if (editData) {
            return (_jsx(PlaceHolder, { placeHolderName: "Configure Feature Card" }));
        }
        return null; // no item - silently skip the widget
        // return (<div>No featured course</div>);
    }
    learningItemCommon = (type && itemID) ? getOrLoad(type, itemID) : undefined;
    if (!portal) {
        return (_jsx("div", { children: "No Portal" }));
    }
    if (!(item && item.itemID && item.type)) {
        if (editData) {
            return (_jsx(PlaceHolder, { placeHolderName: "Configure Feature Card" }));
        }
        // return null; // no course - silently skip the widget
        return (_jsx("div", { children: "No featured course" }));
    }
    if (learningItemCommon?.syncState !== 'loaded') {
        // return (<div>learningItemCommon not loaded</div>);
        return null;
    }
    const { headline, description, 
    // avgRating, reviews,
    companyName, price, sellPrice, } = learningItemCommon;
    const image = learningItemCommon.itemImage();
    const { showPrice: showPriceFromCardConfig, showButton, buttonLabel, action, instructorAction, } = configureSalesCard(portal, learningItemCommon, itemProgress, navigate, location, '.');
    return (_jsx(Card, { sx: {
            boxShadow: '0 0 18px 0 rgba(9, 32, 46, 0.2)',
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: _jsx(CardContent, { children: _jsxs(Grid, { container: true, columnSpacing: 2.5, children: [_jsx(Grid, { item: true, xs: 12, md: 5, children: _jsx(Paper, { elevation: 0, sx: {
                                // bgcolor: 'primary.main',
                                paddingX: 2,
                                pt: 1.5,
                                pb: 0.5,
                                borderRadius: 0,
                            }, children: _jsx(AssetImage, { asset: image, customStyle: {
                                    width: '100%',
                                }, size: "thumb400w" }) }) }), _jsxs(Grid, { container: true, item: true, direction: "column", sm: 12, md: 7, children: [_jsx(PanelTitle, { title: learningItemCommon.name, rootStyle: { mb: 0 }, wrapperStyle: { minHeight: 30 }, className: "courseTitleFeatureCard", dividerStyle: {
                                    borderBottomWidth: '2px',
                                    margin: '13px 0px 9px',
                                    borderColor: (t) => t.portal?.site?.lineColor,
                                } }), _jsxs(Stack, { spacing: 1, divider: _jsx(StyledDivider, {}), children: [(showCourseInfo) && (_jsx(Stack, { direction: "row", justifyContent: "space-between", children: showCourseInfo && (_jsx(CourseInfo, { item: learningItemCommon })) })), _jsx(Stack, { children: _jsx(CourseHeadline, { isShowMore: true, showTitle: showCourseHeadline, headline: headline, description: description, size: "medium" }) }), showOfferedBy && (_jsx(Stack, { direction: "row", children: _jsx(Typography, { variant: "body1", sx: {
                                                marginY: 'auto !important',
                                            }, children: companyName && (_jsxs(Typography, { component: "span", variant: "body1", fontWeight: "fontWeightBold", children: ["OFFERED BY:\u00A0", companyName] })) }) })), showInstructor && (_jsx(Stack, { children: _jsx(ItemInstructors, { showAvatar: true, size: "large", instructors: learningItemCommon.instructors, instructorAction: instructorAction }) })), showEnrollButton !== false && (_jsx(CallToAction, { showPrice: showPrice ?? showPriceFromCardConfig, showButton: showButton, action: action, buttonLabel: buttonLabel, price: price, sellPrice: sellPrice }))] })] })] }) }) }));
};
/**
 * Initiates load of all dependent data.  Returns promise that will
 * resolve once loaded.
 * @param props same props used to render function
 */
FeaturedCard.getData = async ({ item }, store) => {
    console.log('Adding item to preload', item);
    if (!item?.itemID || !item?.type) {
        console.log('No item to load for FeaturedCard');
        return 'ok';
    }
    const { itemID, type } = item;
    const targetItem = await store.load(type, itemID);
    const imageAsset = targetItem.itemImage();
    await store.load('asset', imageAsset.key);
    await store.load('repository', imageAsset.repository?.key);
    await getInstructors(store, targetItem.instructors);
    await imageAsset.getSignedUrl('thumb400w');
    // console.log('imageAsset', imageAsset);
    return 'ok';
};
FeaturedCard.defaultProps = {
    settings: {
        showShareBtns: false,
        showVideo: true,
        showRatings: true,
        showCourseInfo: true,
        showCourseHeadline: true,
        showOrderBy: true,
        showInstructor: true,
        showPrice: true,
        showEnrollButton: true,
    },
    editData: undefined,
    limitToPageWidth: true,
};
FeaturedCard.meta = {
    group: 'display',
    name: 'Feature Card',
    description: 'Component displays the details of an item',
    props: [
        {
            key: 'item',
            name: 'Item',
            type: 'item', // note this is a special type recognized by the system
            description: 'The ID of the item to display information about',
        },
        {
            key: 'settings.showCourseInfo',
            name: 'Show Info',
            type: 'boolean',
            description: 'Show the item info on the card',
        },
        {
            key: 'settings.showCourseHeadline',
            name: 'Show Headline',
            type: 'boolean',
            description: 'Show the item headline on the card',
        },
        {
            key: 'settings.showOfferedBy',
            name: 'Show Offered By',
            type: 'boolean',
            description: 'Show the offered by on the card',
        },
        {
            key: 'settings.showInstructor',
            name: 'Show Instructor',
            type: 'boolean',
            description: 'Show the instructor field on the card',
        },
        {
            key: 'settings.showPrice',
            name: 'Show Price',
            type: 'boolean',
            description: 'Show the price field on the card',
        },
        // {
        //   key: 'settings.showEnrollButton',
        //   name: 'Show Enroll Button',
        //   type: 'boolean',
        //   description: 'Show the enroll button on the card',
        // },
        {
            key: 'limitToPageWidth',
            name: 'Limit To Max Page Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'FeaturedCard',
        props: {
            limitToPageWidth: true,
            item: {
                itemID: null,
                type: null,
            },
            // enrollAction: '@enrollAction',
            settings: {
                showCourseInfo: true,
                showCourseHeadline: true,
                showOfferedBy: true,
                showInstructor: true,
                showPrice: true,
            },
        },
    },
};
export default observer(FeaturedCard);
//# sourceMappingURL=FeaturedCard.js.map